export default {"src":"/_next/static/media/steak.8105adf7.svg","height":50,"width":50};